import app from "../app.json";

const clientFiles = {
    Redbug: require('./redbug.json'),
    IshaFencing: require('./fencing.json'),
    247:require('./247.json'),
    Covid19:require('./covid19.json'),
    Testing: require('./testing.json'),
    Leads:require('./leads.json'),
    Designs:require('./designs.json')
};

const appinfo  = clientFiles[app.jsonFile];
export default appinfo;